module.exports = __webpack_public_path__ + "media/img/auth/pattern-826694918033148275700742463fa09e.png";